export default "__VITE_ASSET__eb3ac9a3__"